// ============================================================
// DESIGN TOKENS & HELPER FUNCTIONS
// Shared across all components in the iRemedy.ai platform
// ============================================================

export const T = {
  // Primary palette (ink/red/paper)
  navy: "#1a1410",
  navyLight: "#3d3529",
  red: "#c8160a",
  redLight: "#e04a3e",
  gold: "#c8160a",
  goldLight: "#e04a3e",
  white: "#FFFFFF",
  offWhite: "#f2ede4",
  cream: "#f2ede4",
  border: "#d4cfc6",
  borderLight: "#e8e3da",
  textDark: "#1a1410",
  textMid: "#6a5f52",
  textLight: "#8a7f72",
  success: "#059669",
  successBg: "#ECFDF5",
  warning: "#D97706",
  warningBg: "#FFFBEB",
  danger: "#DC2626",
  dangerBg: "#FEF2F2",
  infoBg: "#EFF6FF",
  shadow: "0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)",
  shadowMd: "0 4px 6px rgba(0,0,0,0.04), 0 2px 4px rgba(0,0,0,0.03)",
  shadowLg: "0 10px 25px rgba(0,0,0,0.06), 0 4px 10px rgba(0,0,0,0.04)",
  radius: 12,
  radiusSm: 8,

  // iRemedy-family home / app-launcher surfaces (shared with iRemedy Home 1b)
  surfacePage: "#F2EDE4",   // launcher page background (matches iRemedy seller-portal family)
  surfaceCard: "#FCFBF9",   // warm-white — tiles, chips, favorites
  surfaceChat: "#FFFFFF",   // query box (brightest — the hero, per TradeSpy reference)
  favoritesBg: "#E7DFCB",   // favorites band
  borderCard: "rgba(34,48,63,0.07)",
  shadowRest: "0 2px 6px rgba(34,48,63,0.06)",
  shadowHover: "0 12px 26px rgba(34,48,63,0.13)",
  shadowChat: "0 14px 36px rgba(34,48,63,0.15)",
  ink: "#22303F",
};

export const getRiskColor = (risk: string) => {
  switch (risk) {
    case "low": return { bg: T.successBg, text: T.success, border: "#BBF7D0" };
    case "medium": return { bg: T.warningBg, text: T.warning, border: "#FDE68A" };
    case "high": return { bg: T.dangerBg, text: T.danger, border: "#FECACA" };
    default: return { bg: "#F1F5F9", text: "#94A3B8", border: "#E2E8F0" };
  }
};

export const getMIAColor = (score: number) => score >= 75 ? T.success : score >= 50 ? T.warning : score >= 25 ? "#EA580C" : T.danger;
export const getConfidenceColor = (score: number) => score >= 90 ? T.success : score >= 80 ? "#2563EB" : score >= 70 ? T.warning : T.danger;
